import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type ItpProgressBarVariant = 'success' | 'primary' | 'warning' | 'danger' | 'info' | 'neutral';

@Component({
    standalone: false,
    selector: 'itp-progress-bar',
    templateUrl: './itp-progress-bar.component.html',
    styleUrls: ['./itp-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItpProgressBarComponent {
    @Input() value = 0;
    @Input() variant: ItpProgressBarVariant = 'primary';
    @Input() height = '6px';
    @Input() showLabel = false;
    @Input() decimalLabel = false;

    get normalizedValue(): number {
        const numericValue = Number(this.value);
        if (!Number.isFinite(numericValue)) {
            return 0;
        }
        return Math.min(100, Math.max(0, numericValue));
    }

    get trackClass(): string {
        return `itp-progress-bar itp-progress-bar--${this.variant}`;
    }
}
